import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ITreatmentCategory } from '@app/salon-details/models/treatment-category.model';
@Injectable({
  providedIn: 'root',
})
export class TreatmentService {
  constructor(private http: HttpClient) {}

  getTreatmentsByCategories(salonId: string): Observable<ITreatmentCategory[]> {
    return this.http
      .get<ITreatmentCategory[]>(`/api/salontreatments/${salonId}/treatments`);
  }
}
